import axios from 'axios'
import { region } from '#shared/constants/firebase'

export default defineNuxtPlugin((nuxtApp) => {
    const config = useRuntimeConfig()

    // Get function URL using runtime config
    const projectId = config.public.FIREBASE_PROJECT_ID
    const isEmulator = config.public.FIREBASE_USE_EMULATOR === 'true'

    const baseURL = isEmulator
        ? `http://localhost:5001/${projectId}/${region}/api`
        : `https://${region}-${projectId}.cloudfunctions.net/api`

    const API = axios.create({ baseURL })

    API.interceptors.request.use(async (config) => {
        config.headers = config.headers || {}

        // Get auth from Nuxt app (provided by Firebase plugin)
        const { $auth } = nuxtApp

        if ($auth?.currentUser) {
            try {
                const token = await $auth.currentUser.getIdToken()
                if (token) {
                    config.headers.authorization = `Bearer ${token}`
                }
            } catch (error) {
                console.error('Error getting auth token:', error)
            }
        }

        return config
    })

    return {
        provide: {
            api: API
        }
    }
})
